export default "__VITE_ASSET__CprGX8Ij__"